import { addMinutes, isAfter, isBefore, isWeekend, startOfDay } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { last } from "lodash";
import {
  DEFAULT_LOCATION_DATA,
  DEFAULT_REPEAT_ORDER_SETTINGS,
  DELIVERY_TIME_GAP,
  DELIVERY_TIME_GAP_EXPRESS,
} from "../../../constants";
import { formatHours } from "../../../utility/date-fns";
import { isPeakTime } from "../../../utility/helpers/general";
import { generateNewDrop, generateTimePickerData } from "../../../utility/helpers/orders";

export const generatePickUpTimeOptions = ({ startDate, isExpress, withoutPastLimit, timezone }) => {
  if (!startDate) return [];

  const sd = utcToZonedTime(startDate, timezone);

  const options = generateTimePickerData(sd, { withoutPastLimit, timezone, ispickup: true }).map((option) => {
    const date = utcToZonedTime(option.value, timezone);
    const isPeakTimeOption = withoutPastLimit ? isPeakTime(date) : !isWeekend(sd) && isPeakTime(date);
    return isPeakTimeOption ? { ...option, className: "text-color-warning" } : option;
  });

  if (!isExpress) return options;
  return options.filter(({ value }) =>
    isBefore(
      addMinutes(utcToZonedTime(value, timezone), DELIVERY_TIME_GAP_EXPRESS - 1),
      utcToZonedTime(last(options).value, timezone)
    )
  );
};

export const generateDropTimeOptions = ({ startDate, endDate, isExpress, withoutPastLimit, timezone }) => {
  if (!startDate && !endDate) return [];

  const [sd, ed] = [utcToZonedTime(startDate, timezone), utcToZonedTime(endDate, timezone)];

  if (isExpress) {
    return generateTimePickerData(sd, { withoutPastLimit, timezone }).filter(({ value }) => {
      const date = utcToZonedTime(value, timezone);
      return (
        !isBefore(date, addMinutes(sd, DELIVERY_TIME_GAP_EXPRESS - 1)) &&
        isBefore(date, addMinutes(sd, DELIVERY_TIME_GAP - 1))
      );
    });
  }
  return generateTimePickerData(startOfDay(ed), { withoutPastLimit }).filter(({ value }) => {
    return isAfter(utcToZonedTime(value, timezone), addMinutes(sd, DELIVERY_TIME_GAP - 1));
  });
};

export const generateNewOrderRecipient = ({ firstName, lastName, phone, email } = {}) => ({
  name: firstName && lastName ? `${firstName} ${lastName}` : DEFAULT_LOCATION_DATA.recipient.name,
  phone: phone ?? DEFAULT_LOCATION_DATA.recipient.phone,
  email: email ?? DEFAULT_LOCATION_DATA.recipient.email,
});

export const generateNewOrder = (contact) => ({
  startDate: null,
  endDate: null,
  isExpress: false,
  pick_up: { ...DEFAULT_LOCATION_DATA, notes: "", recipient: generateNewOrderRecipient(contact) },
  drops: [generateNewDrop()],
  repeat_settings: DEFAULT_REPEAT_ORDER_SETTINGS,
});

export const prettifyTaskData = (date, address) => {
  return `${formatHours(date)} - ${address.location} | ${address.postcode}`;
};
